import React, { useMemo } from 'react';
import { WrapperField } from '../../../../../components/InputField/WrapperField';
import ButtonGroupNew from '../../BusinessLiteForms/components/ButtonGroupNew';



const MoneyServicesBusiness = ({ applicationForm, asLabel, editMode, data, handleChange, pageNum, loading, step, decrementStep, handleSubmit, bPrimeJSON, showErr, setErrors }) => {
    const hasPlusApplicationWithoutAccountCreated = useMemo(() => !applicationForm?.cyclosUserId && applicationForm?.plus_id, [applicationForm?.cyclosUserId, applicationForm?.plus_id])


    return (
        <>
            <div className='mb-3'>
                <h2 style={{ fontWeight: 'bolder' }} className='pt-3'>Money Services Business</h2>

                <h3 style={{ fontWeight: 'bolder' }} className='pt-2'>
                    What is a Money Services Business?
                </h3>
                <p>
                    A Money Services Business (MSB) refers to a type of financial service provider that offers various services related to money transfers, currency exchange, and payment processing.
                </p>

                <p className='pt-1'>
                    For the purposes of this application, FV Bank considers all of the following to be Money Services Businesses, whether a license is required or not in your jurisdictions. (Exchanges, OTC Providers, Liquidity Providers, Wallet Providers, Non-Bank Financial Institutions, VASPS, DLT's EMI's, PSD license holders, Brokers, Remittance Providers, and FX Providers.)
                </p>

                {(hasPlusApplicationWithoutAccountCreated && data?.isMoneyServiceBusiness != null) ? null :
                    <WrapperField
                        disabled={asLabel}
                        jsonField={bPrimeJSON["isMoneyServiceBusiness"]}
                        dataObj={data}
                        onChange={(updatedData) => handleChange(updatedData)}
                        showError={showErr}
                        onError={(errorMsg) => setErrors((prevErrors) => ({ ...prevErrors, isMoneyServiceBusiness: errorMsg }))}
                    />
                }
                <WrapperField
                    disabled={asLabel}
                    jsonField={bPrimeJSON["primaryMsbBusinessModel"]}
                    dataObj={data}
                    onChange={(updatedData) => handleChange(updatedData)}
                    showError={showErr}
                    onError={(errorMsg) => setErrors((prevErrors) => ({ ...prevErrors, primaryMsbBusinessModel: errorMsg }))}
                />
                <WrapperField
                    disabled={asLabel}
                    jsonField={bPrimeJSON["hasUsCustomers"]}
                    dataObj={data}
                    onChange={(updatedData) => handleChange(updatedData)}
                    showError={showErr}
                    onError={(errorMsg) => setErrors((prevErrors) => ({ ...prevErrors, hasUsCustomers: errorMsg }))}
                />
                <WrapperField
                    disabled={asLabel}
                    jsonField={bPrimeJSON["registeredWithFinCen"]}
                    dataObj={data}
                    onChange={(updatedData) => handleChange(updatedData)}
                    showError={showErr}
                    onError={(errorMsg) => setErrors((prevErrors) => ({ ...prevErrors, registeredWithFinCen: errorMsg }))}
                />
                <WrapperField
                    disabled={asLabel}
                    jsonField={bPrimeJSON["hasMsbLicense"]}
                    dataObj={data}
                    onChange={(updatedData) => handleChange(updatedData)}
                    showError={showErr}
                    onError={(errorMsg) => setErrors((prevErrors) => ({ ...prevErrors, hasMsbLicense: errorMsg }))}
                />
                <WrapperField
                    disabled={asLabel}
                    jsonField={bPrimeJSON["msbLicenseLocation"]}
                    dataObj={data}
                    onChange={(updatedData) => handleChange(updatedData)}
                    showError={showErr}
                    onError={(errorMsg) => setErrors((prevErrors) => ({ ...prevErrors, msbLicenseLocation: errorMsg }))}
                />
                {(hasPlusApplicationWithoutAccountCreated && data?.holdsLicense != null) ? null :
                    <WrapperField
                        disabled={asLabel}
                        jsonField={bPrimeJSON["holdsLicense"]}
                        dataObj={data}
                        onChange={(updatedData) => handleChange(updatedData)}
                        showError={showErr}
                        onError={(errorMsg) => setErrors((prevErrors) => ({ ...prevErrors, holdsLicense: errorMsg }))}
                    />
                }

                {(hasPlusApplicationWithoutAccountCreated && data?.licenseDetails != null) ? null :
                    <WrapperField
                        disabled={asLabel}
                        jsonField={bPrimeJSON["licenseDetails"]}
                        dataObj={data}
                        onChange={(updatedData) => handleChange(updatedData)}
                        showError={showErr}
                        onError={(errorMsg) => setErrors((prevErrors) => ({ ...prevErrors, licenseDetails: errorMsg }))}
                    />
                }

            </div>
            <ButtonGroupNew
                isDisabled={asLabel || editMode}
                pageNum={pageNum}
                showPageNum={false}
                loading={loading}
                asLabel={asLabel || editMode}
                limit={10}
                onNextClick={() => handleSubmit({ isLastStep: false })}
                step={step}
                onBackClick={decrementStep}
            />
        </>
    );
};

export default MoneyServicesBusiness;
